document.documentElement.className = document.documentElement.className.replace('no-js', ''); //Remove no-js class ASAP
//console.log(readCookie('popup_cookie_handler'), 60)
$(document).ready(function(){
 
  $('.shares-container').removeClass('abs').insertBefore('#disqus_thread')
  
  $(window).on('resize', function(){
  	if ( $('.login-heading-content').length ){
  	sign_arr()
  }
  })
  if ($('.login-heading-content').length ){
  	sign_arr()
    
    $('.login-heading-content').prependTo('#content')
  }
  
  function sign_arr(){
    var left = $('.left-login').offset().left;
    var divLeft = $('#customer').offset().left;
    var leftWidth = $('.left-login').width();
    
    $('.login-heading-content h2').css({
      width: leftWidth,
      marginLeft: left
    })
  }
  

  $(window).on('resize', function(){
    login_bg()
  })
  
   $(window).on('load', function(){
    login_bg()
  })
  
  login_bg()
  
  function login_bg(){
    
    var $win = $(window),
        winWidth = $win.width(),
        shellWidth = $('#customer').width(),
        elWidth = winWidth-shellWidth,
        elHalfWidth = elWidth/2;
    
    
    
    $('.login-heading').css('width', elHalfWidth )
  }
 
});

$(document).on('click','a.facebook-link', function(){
  
  call_the_ui();
  
  return false;
})


function call_the_ui() {
  FB.ui(
    {
      method: 'feed',
      name: 'Pura Vida Bracelets: Creating Communities',
      link: 'http://bit.ly/1lAIA9Q',
      picture: "http://cdn.shopify.com/s/files/1/0750/2167/t/6/assets/facebook_page_image.jpg?v=180280427040561577681424128468",
      description: "Over the past three years, Pura Vida Bracelets has grown from a team of two Costa Rican jewelers selling bracelets on a small beach-side table, to a community of over fifty talented artisans."
    });
}

//For keeping track of product data
window.productJSON = [];
function addProductJSON(json) {
  window.productJSON.push(json);
}

//window.selectCallback is standard location for this function. Called whenever variant dropdown changes.
//Shopify's multi-currency code depends on it.
window.selectCallback = function(variant, selector){
  var $form = $(document.getElementById(selector.domIdPrefix)).closest('form');
  var $button = $form.find('input[type="submit"]');
  var $price = $form.closest('.detail').find('.price');
  $form.find('.selector-wrapper .stock-count').remove();
  //Update price & add-to-cart button states
  if(variant && variant.available == true) {
    $button.removeAttr('disabled');
    var priceHTML = Shopify.formatMoney(variant.price);
    if(variant.compare_at_price > variant.price) {
      priceHTML = '<span class="was-price">' + Shopify.formatMoney(variant.compare_at_price) + '</span>' + priceHTML;
    }
    $price.html(priceHTML);
    if(variant.inventory_management == "shopify" && variant.inventory_policy == "deny" && variant.inventory_quantity < 50) {
      $form.find('.selector-wrapper').append('<span class="stock-count in-stock">Hurry, only '+variant.inventory_quantity+' left!</span>');
    }
  } else {
    $button.attr('disabled', 'disabled');
    $price.html(variant ? 'Sold out' : 'Unavailable');
    $form.find('.selector-wrapper').append('<span class="stock-count no-stock">Out of stock</span>');
  }
  
  
   }
   //Lightbox
   var fbOpts = { overlayColor: '#fff', padding: 1, margin: 60, overlayOpacity: 0.9 };
   
   /* Modernizr 2.6.2 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-csstransitions-input-testprop-testallprops-domprefixes-load
 */
   ;window.Modernizr=function(a,b,c){function w(a){i.cssText=a}function x(a,b){return w(prefixes.join(a+";")+(b||""))}function y(a,b){return typeof a===b}function z(a,b){return!!~(""+a).indexOf(b)}function A(a,b){for(var d in a){var e=a[d];if(!z(e,"-")&&i[e]!==c)return b=="pfx"?e:!0}return!1}function B(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:y(f,"function")?f.bind(d||b):f}return!1}function C(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+m.join(d+" ")+d).split(" ");return y(b,"string")||y(b,"undefined")?A(e,b):(e=(a+" "+n.join(d+" ")+d).split(" "),B(e,b,c))}function D(){e.input=function(c){for(var d=0,e=c.length;d<e;d++)q[c[d]]=c[d]in j;return q.list&&(q.list=!!b.createElement("datalist")&&!!a.HTMLDataListElement),q}("autocomplete autofocus list placeholder max min multiple pattern required step".split(" "))}var d="2.6.2",e={},f=b.documentElement,g="modernizr",h=b.createElement(g),i=h.style,j=b.createElement("input"),k={}.toString,l="Webkit Moz O ms",m=l.split(" "),n=l.toLowerCase().split(" "),o={},p={},q={},r=[],s=r.slice,t,u={}.hasOwnProperty,v;!y(u,"undefined")&&!y(u.call,"undefined")?v=function(a,b){return u.call(a,b)}:v=function(a,b){return b in a&&y(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=s.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(s.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(s.call(arguments)))};return e}),o.csstransitions=function(){return C("transition")};for(var E in o)v(o,E)&&(t=E.toLowerCase(),e[t]=o[E](),r.push((e[t]?"":"no-")+t));return e.input||D(),e.addTest=function(a,b){if(typeof a=="object")for(var d in a)v(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof enableClasses!="undefined"&&enableClasses&&(f.className+=" "+(b?"":"no-")+a),e[a]=b}return e},w(""),h=j=null,e._version=d,e._domPrefixes=n,e._cssomPrefixes=m,e.testProp=function(a){return A([a])},e.testAllProps=C,e}(this,this.document),function(a,b,c){function d(a){return"[object Function]"==o.call(a)}function e(a){return"string"==typeof a}function f(){}function g(a){return!a||"loaded"==a||"complete"==a||"uninitialized"==a}function h(){var a=p.shift();q=1,a?a.t?m(function(){("c"==a.t?B.injectCss:B.injectJs)(a.s,0,a.a,a.x,a.e,1)},0):(a(),h()):q=0}function i(a,c,d,e,f,i,j){function k(b){if(!o&&g(l.readyState)&&(u.r=o=1,!q&&h(),l.onload=l.onreadystatechange=null,b)){"img"!=a&&m(function(){t.removeChild(l)},50);for(var d in y[c])y[c].hasOwnProperty(d)&&y[c][d].onload()}}var j=j||B.errorTimeout,l=b.createElement(a),o=0,r=0,u={t:d,s:c,e:f,a:i,x:j};1===y[c]&&(r=1,y[c]=[]),"object"==a?l.data=c:(l.src=c,l.type=a),l.width=l.height="0",l.onerror=l.onload=l.onreadystatechange=function(){k.call(this,r)},p.splice(e,0,u),"img"!=a&&(r||2===y[c]?(t.insertBefore(l,s?null:n),m(k,j)):y[c].push(l))}function j(a,b,c,d,f){return q=0,b=b||"j",e(a)?i("c"==b?v:u,a,b,this.i++,c,d,f):(p.splice(this.i++,0,a),1==p.length&&h()),this}function k(){var a=B;return a.loader={load:j,i:0},a}var l=b.documentElement,m=a.setTimeout,n=b.getElementsByTagName("script")[0],o={}.toString,p=[],q=0,r="MozAppearance"in l.style,s=r&&!!b.createRange().compareNode,t=s?l:n.parentNode,l=a.opera&&"[object Opera]"==o.call(a.opera),l=!!b.attachEvent&&!l,u=r?"object":l?"script":"img",v=l?"script":u,w=Array.isArray||function(a){return"[object Array]"==o.call(a)},x=[],y={},z={timeout:function(a,b){return b.length&&(a.timeout=b[0]),a}},A,B;B=function(a){function b(a){var a=a.split("!"),b=x.length,c=a.pop(),d=a.length,c={url:c,origUrl:c,prefixes:a},e,f,g;for(f=0;f<d;f++)g=a[f].split("="),(e=z[g.shift()])&&(c=e(c,g));for(f=0;f<b;f++)c=x[f](c);return c}function g(a,e,f,g,h){var i=b(a),j=i.autoCallback;i.url.split(".").pop().split("?").shift(),i.bypass||(e&&(e=d(e)?e:e[a]||e[g]||e[a.split("/").pop().split("?")[0]]),i.instead?i.instead(a,e,f,g,h):(y[i.url]?i.noexec=!0:y[i.url]=1,f.load(i.url,i.forceCSS||!i.forceJS&&"css"==i.url.split(".").pop().split("?").shift()?"c":c,i.noexec,i.attrs,i.timeout),(d(e)||d(j))&&f.load(function(){k(),e&&e(i.origUrl,h,g),j&&j(i.origUrl,h,g),y[i.url]=2})))}function h(a,b){function c(a,c){if(a){if(e(a))c||(j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}),g(a,j,b,0,h);else if(Object(a)===a)for(n in m=function(){var b=0,c;for(c in a)a.hasOwnProperty(c)&&b++;return b}(),a)a.hasOwnProperty(n)&&(!c&&!--m&&(d(j)?j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}:j[n]=function(a){return function(){var b=[].slice.call(arguments);a&&a.apply(this,b),l()}}(k[n])),g(a[n],j,b,n,h))}else!c&&l()}var h=!!a.test,i=a.load||a.both,j=a.callback||f,k=j,l=a.complete||f,m,n;c(h?a.yep:a.nope,!!i),i&&c(i)}var i,j,l=this.yepnope.loader;if(e(a))g(a,0,l,0);else if(w(a))for(i=0;i<a.length;i++)j=a[i],e(j)?g(j,0,l,0):w(j)?B(j):Object(j)===j&&h(j,l);else Object(a)===a&&h(a,l)},B.addPrefix=function(a,b){z[a]=b},B.addFilter=function(a){x.push(a)},B.errorTimeout=1e4,null==b.readyState&&b.addEventListener&&(b.readyState="loading",b.addEventListener("DOMContentLoaded",A=function(){b.removeEventListener("DOMContentLoaded",A,0),b.readyState="complete"},0)),a.yepnope=k(),a.yepnope.executeStack=h,a.yepnope.injectJs=function(a,c,d,e,i,j){var k=b.createElement("script"),l,o,e=e||B.errorTimeout;k.src=a;for(o in d)k.setAttribute(o,d[o]);c=j?h:c||f,k.onreadystatechange=k.onload=function(){!l&&g(k.readyState)&&(l=1,c(),k.onload=k.onreadystatechange=null)},m(function(){l||(l=1,c(1))},e),i?k.onload():n.parentNode.insertBefore(k,n)},a.yepnope.injectCss=function(a,c,d,e,g,i){var e=b.createElement("link"),j,c=i?h:c||f;e.href=a,e.rel="stylesheet",e.type="text/css";for(j in d)e.setAttribute(j,d[j]);g||(n.parentNode.insertBefore(e,n),m(c,0))}}(this,document),Modernizr.load=function(){yepnope.apply(window,[].slice.call(arguments,0))};
   
   /* Placeholders.js v2.1.1 */
   (function(t){"use strict";function e(t,e,r){return t.addEventListener?t.addEventListener(e,r,!1):t.attachEvent?t.attachEvent("on"+e,r):void 0}function r(t,e){var r,n;for(r=0,n=t.length;n>r;r++)if(t[r]===e)return!0;return!1}function n(t,e){var r;t.createTextRange?(r=t.createTextRange(),r.move("character",e),r.select()):t.selectionStart&&(t.focus(),t.setSelectionRange(e,e))}function a(t,e){try{return t.type=e,!0}catch(r){return!1}}t.Placeholders={Utils:{addEventListener:e,inArray:r,moveCaret:n,changeType:a}}})(this),function(t){"use strict";function e(){}function r(t,e){var r,n,a=!!e&&t.value!==e,u=t.value===t.getAttribute(V);return(a||u)&&"true"===t.getAttribute(D)?(t.setAttribute(D,"false"),t.value=t.value.replace(t.getAttribute(V),""),t.className=t.className.replace(R,""),n=t.getAttribute(z),n&&(t.setAttribute("maxLength",n),t.removeAttribute(z)),r=t.getAttribute(I),r&&(t.type=r),!0):!1}function n(t){var e,r,n=t.getAttribute(V);return""===t.value&&n?(t.setAttribute(D,"true"),t.value=n,t.className+=" "+k,r=t.getAttribute(z),r||(t.setAttribute(z,t.maxLength),t.removeAttribute("maxLength")),e=t.getAttribute(I),e?t.type="text":"password"===t.type&&K.changeType(t,"text")&&t.setAttribute(I,"password"),!0):!1}function a(t,e){var r,n,a,u,i;if(t&&t.getAttribute(V))e(t);else for(r=t?t.getElementsByTagName("input"):p,n=t?t.getElementsByTagName("textarea"):h,i=0,u=r.length+n.length;u>i;i++)a=r.length>i?r[i]:n[i-r.length],e(a)}function u(t){a(t,r)}function i(t){a(t,n)}function l(t){return function(){b&&t.value===t.getAttribute(V)&&"true"===t.getAttribute(D)?K.moveCaret(t,0):r(t)}}function o(t){return function(){n(t)}}function c(t){return function(e){return m=t.value,"true"===t.getAttribute(D)&&m===t.getAttribute(V)&&K.inArray(C,e.keyCode)?(e.preventDefault&&e.preventDefault(),!1):void 0}}function s(t){return function(){r(t,m),""===t.value&&(t.blur(),K.moveCaret(t,0))}}function d(t){return function(){t===document.activeElement&&t.value===t.getAttribute(V)&&"true"===t.getAttribute(D)&&K.moveCaret(t,0)}}function g(t){return function(){u(t)}}function v(t){t.form&&(L=t.form,L.getAttribute(P)||(K.addEventListener(L,"submit",g(L)),L.setAttribute(P,"true"))),K.addEventListener(t,"focus",l(t)),K.addEventListener(t,"blur",o(t)),b&&(K.addEventListener(t,"keydown",c(t)),K.addEventListener(t,"keyup",s(t)),K.addEventListener(t,"click",d(t))),t.setAttribute(U,"true"),t.setAttribute(V,E),n(t)}var p,h,b,f,m,A,y,E,x,L,T,N,S,w=["text","search","url","tel","email","password","number","textarea"],C=[27,33,34,35,36,37,38,39,40,8,46],B="#ccc",k="placeholdersjs",R=RegExp("(?:^|\\s)"+k+"(?!\\S)"),V="data-placeholder-value",D="data-placeholder-active",I="data-placeholder-type",P="data-placeholder-submit",U="data-placeholder-bound",j="data-placeholder-focus",q="data-placeholder-live",z="data-placeholder-maxlength",F=document.createElement("input"),G=document.getElementsByTagName("head")[0],H=document.documentElement,J=t.Placeholders,K=J.Utils;if(J.nativeSupport=void 0!==F.placeholder,!J.nativeSupport){for(p=document.getElementsByTagName("input"),h=document.getElementsByTagName("textarea"),b="false"===H.getAttribute(j),f="false"!==H.getAttribute(q),A=document.createElement("style"),A.type="text/css",y=document.createTextNode("."+k+" { color:"+B+"; }"),A.styleSheet?A.styleSheet.cssText=y.nodeValue:A.appendChild(y),G.insertBefore(A,G.firstChild),S=0,N=p.length+h.length;N>S;S++)T=p.length>S?p[S]:h[S-p.length],E=T.attributes.placeholder,E&&(E=E.nodeValue,E&&K.inArray(w,T.type)&&v(T));x=setInterval(function(){for(S=0,N=p.length+h.length;N>S;S++)T=p.length>S?p[S]:h[S-p.length],E=T.attributes.placeholder,E&&(E=E.nodeValue,E&&K.inArray(w,T.type)&&(T.getAttribute(U)||v(T),(E!==T.getAttribute(V)||"password"===T.type&&!T.getAttribute(I))&&("password"===T.type&&!T.getAttribute(I)&&K.changeType(T,"text")&&T.setAttribute(I,"password"),T.value===T.getAttribute(V)&&(T.value=E),T.setAttribute(V,E))));f||clearInterval(x)},100)}J.disable=J.nativeSupport?e:u,J.enable=J.nativeSupport?e:i}(this);
   

/*! Lazy Load 1.9.3 - MIT license - Copyright 2010-2013 Mika Tuupola */
!function(a,b,c,d){var e=a(b);a.fn.lazyload=function(f){function g(){var b=0;i.each(function(){var c=a(this);if(!j.skip_invisible||c.is(":visible"))if(a.abovethetop(this,j)||a.leftofbegin(this,j));else if(a.belowthefold(this,j)||a.rightoffold(this,j)){if(++b>j.failure_limit)return!1}else c.trigger("appear"),b=0})}var h,i=this,j={threshold:0,failure_limit:0,event:"scroll",effect:"show",container:b,data_attribute:"original",skip_invisible:!0,appear:null,load:null,placeholder:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"};return f&&(d!==f.failurelimit&&(f.failure_limit=f.failurelimit,delete f.failurelimit),d!==f.effectspeed&&(f.effect_speed=f.effectspeed,delete f.effectspeed),a.extend(j,f)),h=j.container===d||j.container===b?e:a(j.container),0===j.event.indexOf("scroll")&&h.bind(j.event,function(){return g()}),this.each(function(){var b=this,c=a(b);b.loaded=!1,(c.attr("src")===d||c.attr("src")===!1)&&c.is("img")&&c.attr("src",j.placeholder),c.one("appear",function(){if(!this.loaded){if(j.appear){var d=i.length;j.appear.call(b,d,j)}a("<img />").bind("load",function(){var d=c.attr("data-"+j.data_attribute);c.hide(),c.is("img")?c.attr("src",d):c.css("background-image","url('"+d+"')"),c[j.effect](j.effect_speed),b.loaded=!0;var e=a.grep(i,function(a){return!a.loaded});if(i=a(e),j.load){var f=i.length;j.load.call(b,f,j)}}).attr("src",c.attr("data-"+j.data_attribute))}}),0!==j.event.indexOf("scroll")&&c.bind(j.event,function(){b.loaded||c.trigger("appear")})}),e.bind("resize",function(){g()}),/(?:iphone|ipod|ipad).*os 5/gi.test(navigator.appVersion)&&e.bind("pageshow",function(b){b.originalEvent&&b.originalEvent.persisted&&i.each(function(){a(this).trigger("appear")})}),a(c).ready(function(){g()}),this},a.belowthefold=function(c,f){var g;return g=f.container===d||f.container===b?(b.innerHeight?b.innerHeight:e.height())+e.scrollTop():a(f.container).offset().top+a(f.container).height(),g<=a(c).offset().top-f.threshold},a.rightoffold=function(c,f){var g;return g=f.container===d||f.container===b?e.width()+e.scrollLeft():a(f.container).offset().left+a(f.container).width(),g<=a(c).offset().left-f.threshold},a.abovethetop=function(c,f){var g;return g=f.container===d||f.container===b?e.scrollTop():a(f.container).offset().top,g>=a(c).offset().top+f.threshold+a(c).height()},a.leftofbegin=function(c,f){var g;return g=f.container===d||f.container===b?e.scrollLeft():a(f.container).offset().left,g>=a(c).offset().left+f.threshold+a(c).width()},a.inviewport=function(b,c){return!(a.rightoffold(b,c)||a.leftofbegin(b,c)||a.belowthefold(b,c)||a.abovethetop(b,c))},a.extend(a.expr[":"],{"below-the-fold":function(b){return a.belowthefold(b,{threshold:0})},"above-the-top":function(b){return!a.belowthefold(b,{threshold:0})},"right-of-screen":function(b){return a.rightoffold(b,{threshold:0})},"left-of-screen":function(b){return!a.rightoffold(b,{threshold:0})},"in-viewport":function(b){return a.inviewport(b,{threshold:0})},"above-the-fold":function(b){return!a.belowthefold(b,{threshold:0})},"right-of-fold":function(b){return a.rightoffold(b,{threshold:0})},"left-of-fold":function(b){return!a.rightoffold(b,{threshold:0})}})}(jQuery,window,document);

/* willFillParent - I made this! */
(function(e){e.fn.willFillParent=function(t){var n=e.extend({closest:false,windowEvent:false,loadingHTML:"",changeURL:false},t);e(this).each(function(){var t=e(this);if(n.changeURL!==false&&n.changeURL!=t.attr("src")){var r=t.data("fillcont");var i=e('<span class="loading"/>').html(n.loadingHTML).appendTo(r);t.fadeOut(500,function(){e(this).remove()});t=e("<img/>").attr("src",n.changeURL).appendTo(r).data("fillcont",r)}if(t.data("willloaded")){var r=t.data("fillcont");r.css({position:r.css("position")=="static"?"relative":null,overflow:"hidden"});var s=r.outerWidth();var o=r.css("min-height")=="1px"?screen.height:r.outerHeight();var u=s/o;t.css({position:"absolute",maxWidth:"none"});if(u>t.data("nr")){var a=s/t.data("nr");t.css({width:s,height:a,left:0,top:(o-a)/2})}else{var f=o*t.data("nr");t.css({width:f,height:o,left:(s-f)/2,top:0})}}else{if(typeof t.data("fillcont")==="undefined"){if(n.closest){t.data("fillcont",t.closest(n.closest))}else{t.data("fillcont",t.parent())}}if(t.is("img")){t.imagesLoaded(function(){t.data("nw",t.width()).data("nh",t.height()).data("nr",t.data("nw")/t.data("nh")).data("willloaded",true).addClass("loaded").willFillParent();t.on("load",function(){t.css({height:"",width:""}).data("nw",t.width()).data("nh",t.height()).data("nr",t.data("nw")/t.data("nh")).willFillParent()});t.data("fillcont").find(".loading").stop().fadeOut(250,function(){e(this).remove()})})}else{var l=t.attr("width");var c=t.attr("height");t.data("nw",l).data("nh",c).data("nr",l/c).data("doFitRatherThanFill",n.doFitRatherThanFill).data("willloaded",true).willFillParent()}}});if(n.windowEvent&&n.windowEvent!=null){var r=e(this);var i=n.windowEvent+".willFillParent";e(window).on(i,function(){r.willFillParent()})}return e(this)}})(jQuery);

   /*
* debouncedresize: special jQuery event that happens once after a window resize
*
* latest version and complete README available on Github:
* https://github.com/louisremi/jquery-smartresize/blob/master/jquery.debouncedresize.js
*
* Copyright 2011 @louis_remi
* Licensed under the MIT license.
*/
(function($) {
  var $event = $.event,
      $special,
      resizeTimeout;

  $special = $event.special.debouncedresize = {
    setup: function() {
      $( this ).on( "resize", $special.handler );
    },
    teardown: function() {
      $( this ).off( "resize", $special.handler );
    },
    handler: function( event, execAsap ) {
      // Save the context
      var context = this,
          args = arguments,
          dispatch = function() {
            // set correct event type
            event.type = "debouncedresize";
            $event.dispatch.apply( context, args );
          };

      if ( resizeTimeout ) {
        clearTimeout( resizeTimeout );
      }

      execAsap ?
        dispatch() :
      resizeTimeout = setTimeout( dispatch, $special.threshold );
    },
    threshold: 200
  };
})(jQuery);

/*!
 * Masonry PACKAGED v3.2.2
 * Cascading grid layout library
 * http://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

!function(a){function b(){}function c(a){function c(b){b.prototype.option||(b.prototype.option=function(b){a.isPlainObject(b)&&(this.options=a.extend(!0,this.options,b))})}function e(b,c){a.fn[b]=function(e){if("string"==typeof e){for(var g=d.call(arguments,1),h=0,i=this.length;i>h;h++){var j=this[h],k=a.data(j,b);if(k)if(a.isFunction(k[e])&&"_"!==e.charAt(0)){var l=k[e].apply(k,g);if(void 0!==l)return l}else f("no such method '"+e+"' for "+b+" instance");else f("cannot call methods on "+b+" prior to initialization; attempted to call '"+e+"'")}return this}return this.each(function(){var d=a.data(this,b);d?(d.option(e),d._init()):(d=new c(this,e),a.data(this,b,d))})}}if(a){var f="undefined"==typeof console?b:function(a){console.error(a)};return a.bridget=function(a,b){c(b),e(a,b)},a.bridget}}var d=Array.prototype.slice;"function"==typeof define&&define.amd?define("jquery-bridget/jquery.bridget",["jquery"],c):c("object"==typeof exports?require("jquery"):a.jQuery)}(window),function(a){function b(b){var c=a.event;return c.target=c.target||c.srcElement||b,c}var c=document.documentElement,d=function(){};c.addEventListener?d=function(a,b,c){a.addEventListener(b,c,!1)}:c.attachEvent&&(d=function(a,c,d){a[c+d]=d.handleEvent?function(){var c=b(a);d.handleEvent.call(d,c)}:function(){var c=b(a);d.call(a,c)},a.attachEvent("on"+c,a[c+d])});var e=function(){};c.removeEventListener?e=function(a,b,c){a.removeEventListener(b,c,!1)}:c.detachEvent&&(e=function(a,b,c){a.detachEvent("on"+b,a[b+c]);try{delete a[b+c]}catch(d){a[b+c]=void 0}});var f={bind:d,unbind:e};"function"==typeof define&&define.amd?define("eventie/eventie",f):"object"==typeof exports?module.exports=f:a.eventie=f}(this),function(a){function b(a){"function"==typeof a&&(b.isReady?a():g.push(a))}function c(a){var c="readystatechange"===a.type&&"complete"!==f.readyState;b.isReady||c||d()}function d(){b.isReady=!0;for(var a=0,c=g.length;c>a;a++){var d=g[a];d()}}function e(e){return"complete"===f.readyState?d():(e.bind(f,"DOMContentLoaded",c),e.bind(f,"readystatechange",c),e.bind(a,"load",c)),b}var f=a.document,g=[];b.isReady=!1,"function"==typeof define&&define.amd?define("doc-ready/doc-ready",["eventie/eventie"],e):"object"==typeof exports?module.exports=e(require("eventie")):a.docReady=e(a.eventie)}(window),function(){function a(){}function b(a,b){for(var c=a.length;c--;)if(a[c].listener===b)return c;return-1}function c(a){return function(){return this[a].apply(this,arguments)}}var d=a.prototype,e=this,f=e.EventEmitter;d.getListeners=function(a){var b,c,d=this._getEvents();if(a instanceof RegExp){b={};for(c in d)d.hasOwnProperty(c)&&a.test(c)&&(b[c]=d[c])}else b=d[a]||(d[a]=[]);return b},d.flattenListeners=function(a){var b,c=[];for(b=0;b<a.length;b+=1)c.push(a[b].listener);return c},d.getListenersAsObject=function(a){var b,c=this.getListeners(a);return c instanceof Array&&(b={},b[a]=c),b||c},d.addListener=function(a,c){var d,e=this.getListenersAsObject(a),f="object"==typeof c;for(d in e)e.hasOwnProperty(d)&&-1===b(e[d],c)&&e[d].push(f?c:{listener:c,once:!1});return this},d.on=c("addListener"),d.addOnceListener=function(a,b){return this.addListener(a,{listener:b,once:!0})},d.once=c("addOnceListener"),d.defineEvent=function(a){return this.getListeners(a),this},d.defineEvents=function(a){for(var b=0;b<a.length;b+=1)this.defineEvent(a[b]);return this},d.removeListener=function(a,c){var d,e,f=this.getListenersAsObject(a);for(e in f)f.hasOwnProperty(e)&&(d=b(f[e],c),-1!==d&&f[e].splice(d,1));return this},d.off=c("removeListener"),d.addListeners=function(a,b){return this.manipulateListeners(!1,a,b)},d.removeListeners=function(a,b){return this.manipulateListeners(!0,a,b)},d.manipulateListeners=function(a,b,c){var d,e,f=a?this.removeListener:this.addListener,g=a?this.removeListeners:this.addListeners;if("object"!=typeof b||b instanceof RegExp)for(d=c.length;d--;)f.call(this,b,c[d]);else for(d in b)b.hasOwnProperty(d)&&(e=b[d])&&("function"==typeof e?f.call(this,d,e):g.call(this,d,e));return this},d.removeEvent=function(a){var b,c=typeof a,d=this._getEvents();if("string"===c)delete d[a];else if(a instanceof RegExp)for(b in d)d.hasOwnProperty(b)&&a.test(b)&&delete d[b];else delete this._events;return this},d.removeAllListeners=c("removeEvent"),d.emitEvent=function(a,b){var c,d,e,f,g=this.getListenersAsObject(a);for(e in g)if(g.hasOwnProperty(e))for(d=g[e].length;d--;)c=g[e][d],c.once===!0&&this.removeListener(a,c.listener),f=c.listener.apply(this,b||[]),f===this._getOnceReturnValue()&&this.removeListener(a,c.listener);return this},d.trigger=c("emitEvent"),d.emit=function(a){var b=Array.prototype.slice.call(arguments,1);return this.emitEvent(a,b)},d.setOnceReturnValue=function(a){return this._onceReturnValue=a,this},d._getOnceReturnValue=function(){return this.hasOwnProperty("_onceReturnValue")?this._onceReturnValue:!0},d._getEvents=function(){return this._events||(this._events={})},a.noConflict=function(){return e.EventEmitter=f,a},"function"==typeof define&&define.amd?define("eventEmitter/EventEmitter",[],function(){return a}):"object"==typeof module&&module.exports?module.exports=a:e.EventEmitter=a}.call(this),function(a){function b(a){if(a){if("string"==typeof d[a])return a;a=a.charAt(0).toUpperCase()+a.slice(1);for(var b,e=0,f=c.length;f>e;e++)if(b=c[e]+a,"string"==typeof d[b])return b}}var c="Webkit Moz ms Ms O".split(" "),d=document.documentElement.style;"function"==typeof define&&define.amd?define("get-style-property/get-style-property",[],function(){return b}):"object"==typeof exports?module.exports=b:a.getStyleProperty=b}(window),function(a){function b(a){var b=parseFloat(a),c=-1===a.indexOf("%")&&!isNaN(b);return c&&b}function c(){}function d(){for(var a={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},b=0,c=g.length;c>b;b++){var d=g[b];a[d]=0}return a}function e(c){function e(){if(!m){m=!0;var d=a.getComputedStyle;if(j=function(){var a=d?function(a){return d(a,null)}:function(a){return a.currentStyle};return function(b){var c=a(b);return c||f("Style returned "+c+". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"),c}}(),k=c("boxSizing")){var e=document.createElement("div");e.style.width="200px",e.style.padding="1px 2px 3px 4px",e.style.borderStyle="solid",e.style.borderWidth="1px 2px 3px 4px",e.style[k]="border-box";var g=document.body||document.documentElement;g.appendChild(e);var h=j(e);l=200===b(h.width),g.removeChild(e)}}}function h(a){if(e(),"string"==typeof a&&(a=document.querySelector(a)),a&&"object"==typeof a&&a.nodeType){var c=j(a);if("none"===c.display)return d();var f={};f.width=a.offsetWidth,f.height=a.offsetHeight;for(var h=f.isBorderBox=!(!k||!c[k]||"border-box"!==c[k]),m=0,n=g.length;n>m;m++){var o=g[m],p=c[o];p=i(a,p);var q=parseFloat(p);f[o]=isNaN(q)?0:q}var r=f.paddingLeft+f.paddingRight,s=f.paddingTop+f.paddingBottom,t=f.marginLeft+f.marginRight,u=f.marginTop+f.marginBottom,v=f.borderLeftWidth+f.borderRightWidth,w=f.borderTopWidth+f.borderBottomWidth,x=h&&l,y=b(c.width);y!==!1&&(f.width=y+(x?0:r+v));var z=b(c.height);return z!==!1&&(f.height=z+(x?0:s+w)),f.innerWidth=f.width-(r+v),f.innerHeight=f.height-(s+w),f.outerWidth=f.width+t,f.outerHeight=f.height+u,f}}function i(b,c){if(a.getComputedStyle||-1===c.indexOf("%"))return c;var d=b.style,e=d.left,f=b.runtimeStyle,g=f&&f.left;return g&&(f.left=b.currentStyle.left),d.left=c,c=d.pixelLeft,d.left=e,g&&(f.left=g),c}var j,k,l,m=!1;return h}var f="undefined"==typeof console?c:function(a){console.error(a)},g=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"];"function"==typeof define&&define.amd?define("get-size/get-size",["get-style-property/get-style-property"],e):"object"==typeof exports?module.exports=e(require("desandro-get-style-property")):a.getSize=e(a.getStyleProperty)}(window),function(a){function b(a,b){return a[g](b)}function c(a){if(!a.parentNode){var b=document.createDocumentFragment();b.appendChild(a)}}function d(a,b){c(a);for(var d=a.parentNode.querySelectorAll(b),e=0,f=d.length;f>e;e++)if(d[e]===a)return!0;return!1}function e(a,d){return c(a),b(a,d)}var f,g=function(){if(a.matchesSelector)return"matchesSelector";for(var b=["webkit","moz","ms","o"],c=0,d=b.length;d>c;c++){var e=b[c],f=e+"MatchesSelector";if(a[f])return f}}();if(g){var h=document.createElement("div"),i=b(h,"div");f=i?b:e}else f=d;"function"==typeof define&&define.amd?define("matches-selector/matches-selector",[],function(){return f}):"object"==typeof exports?module.exports=f:window.matchesSelector=f}(Element.prototype),function(a){function b(a,b){for(var c in b)a[c]=b[c];return a}function c(a){for(var b in a)return!1;return b=null,!0}function d(a){return a.replace(/([A-Z])/g,function(a){return"-"+a.toLowerCase()})}function e(a,e,f){function h(a,b){a&&(this.element=a,this.layout=b,this.position={x:0,y:0},this._create())}var i=f("transition"),j=f("transform"),k=i&&j,l=!!f("perspective"),m={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"otransitionend",transition:"transitionend"}[i],n=["transform","transition","transitionDuration","transitionProperty"],o=function(){for(var a={},b=0,c=n.length;c>b;b++){var d=n[b],e=f(d);e&&e!==d&&(a[d]=e)}return a}();b(h.prototype,a.prototype),h.prototype._create=function(){this._transn={ingProperties:{},clean:{},onEnd:{}},this.css({position:"absolute"})},h.prototype.handleEvent=function(a){var b="on"+a.type;this[b]&&this[b](a)},h.prototype.getSize=function(){this.size=e(this.element)},h.prototype.css=function(a){var b=this.element.style;for(var c in a){var d=o[c]||c;b[d]=a[c]}},h.prototype.getPosition=function(){var a=g(this.element),b=this.layout.options,c=b.isOriginLeft,d=b.isOriginTop,e=parseInt(a[c?"left":"right"],10),f=parseInt(a[d?"top":"bottom"],10);e=isNaN(e)?0:e,f=isNaN(f)?0:f;var h=this.layout.size;e-=c?h.paddingLeft:h.paddingRight,f-=d?h.paddingTop:h.paddingBottom,this.position.x=e,this.position.y=f},h.prototype.layoutPosition=function(){var a=this.layout.size,b=this.layout.options,c={};b.isOriginLeft?(c.left=this.position.x+a.paddingLeft+"px",c.right=""):(c.right=this.position.x+a.paddingRight+"px",c.left=""),b.isOriginTop?(c.top=this.position.y+a.paddingTop+"px",c.bottom=""):(c.bottom=this.position.y+a.paddingBottom+"px",c.top=""),this.css(c),this.emitEvent("layout",[this])};var p=l?function(a,b){return"translate3d("+a+"px, "+b+"px, 0)"}:function(a,b){return"translate("+a+"px, "+b+"px)"};h.prototype._transitionTo=function(a,b){this.getPosition();var c=this.position.x,d=this.position.y,e=parseInt(a,10),f=parseInt(b,10),g=e===this.position.x&&f===this.position.y;if(this.setPosition(a,b),g&&!this.isTransitioning)return void this.layoutPosition();var h=a-c,i=b-d,j={},k=this.layout.options;h=k.isOriginLeft?h:-h,i=k.isOriginTop?i:-i,j.transform=p(h,i),this.transition({to:j,onTransitionEnd:{transform:this.layoutPosition},isCleaning:!0})},h.prototype.goTo=function(a,b){this.setPosition(a,b),this.layoutPosition()},h.prototype.moveTo=k?h.prototype._transitionTo:h.prototype.goTo,h.prototype.setPosition=function(a,b){this.position.x=parseInt(a,10),this.position.y=parseInt(b,10)},h.prototype._nonTransition=function(a){this.css(a.to),a.isCleaning&&this._removeStyles(a.to);for(var b in a.onTransitionEnd)a.onTransitionEnd[b].call(this)},h.prototype._transition=function(a){if(!parseFloat(this.layout.options.transitionDuration))return void this._nonTransition(a);var b=this._transn;for(var c in a.onTransitionEnd)b.onEnd[c]=a.onTransitionEnd[c];for(c in a.to)b.ingProperties[c]=!0,a.isCleaning&&(b.clean[c]=!0);if(a.from){this.css(a.from);var d=this.element.offsetHeight;d=null}this.enableTransition(a.to),this.css(a.to),this.isTransitioning=!0};var q=j&&d(j)+",opacity";h.prototype.enableTransition=function(){this.isTransitioning||(this.css({transitionProperty:q,transitionDuration:this.layout.options.transitionDuration}),this.element.addEventListener(m,this,!1))},h.prototype.transition=h.prototype[i?"_transition":"_nonTransition"],h.prototype.onwebkitTransitionEnd=function(a){this.ontransitionend(a)},h.prototype.onotransitionend=function(a){this.ontransitionend(a)};var r={"-webkit-transform":"transform","-moz-transform":"transform","-o-transform":"transform"};h.prototype.ontransitionend=function(a){if(a.target===this.element){var b=this._transn,d=r[a.propertyName]||a.propertyName;if(delete b.ingProperties[d],c(b.ingProperties)&&this.disableTransition(),d in b.clean&&(this.element.style[a.propertyName]="",delete b.clean[d]),d in b.onEnd){var e=b.onEnd[d];e.call(this),delete b.onEnd[d]}this.emitEvent("transitionEnd",[this])}},h.prototype.disableTransition=function(){this.removeTransitionStyles(),this.element.removeEventListener(m,this,!1),this.isTransitioning=!1},h.prototype._removeStyles=function(a){var b={};for(var c in a)b[c]="";this.css(b)};var s={transitionProperty:"",transitionDuration:""};return h.prototype.removeTransitionStyles=function(){this.css(s)},h.prototype.removeElem=function(){this.element.parentNode.removeChild(this.element),this.emitEvent("remove",[this])},h.prototype.remove=function(){if(!i||!parseFloat(this.layout.options.transitionDuration))return void this.removeElem();var a=this;this.on("transitionEnd",function(){return a.removeElem(),!0}),this.hide()},h.prototype.reveal=function(){delete this.isHidden,this.css({display:""});var a=this.layout.options;this.transition({from:a.hiddenStyle,to:a.visibleStyle,isCleaning:!0})},h.prototype.hide=function(){this.isHidden=!0,this.css({display:""});var a=this.layout.options;this.transition({from:a.visibleStyle,to:a.hiddenStyle,isCleaning:!0,onTransitionEnd:{opacity:function(){this.isHidden&&this.css({display:"none"})}}})},h.prototype.destroy=function(){this.css({position:"",left:"",right:"",top:"",bottom:"",transition:"",transform:""})},h}var f=a.getComputedStyle,g=f?function(a){return f(a,null)}:function(a){return a.currentStyle};"function"==typeof define&&define.amd?define("outlayer/item",["eventEmitter/EventEmitter","get-size/get-size","get-style-property/get-style-property"],e):"object"==typeof exports?module.exports=e(require("wolfy87-eventemitter"),require("get-size"),require("desandro-get-style-property")):(a.Outlayer={},a.Outlayer.Item=e(a.EventEmitter,a.getSize,a.getStyleProperty))}(window),function(a){function b(a,b){for(var c in b)a[c]=b[c];return a}function c(a){return"[object Array]"===l.call(a)}function d(a){var b=[];if(c(a))b=a;else if(a&&"number"==typeof a.length)for(var d=0,e=a.length;e>d;d++)b.push(a[d]);else b.push(a);return b}function e(a,b){var c=n(b,a);-1!==c&&b.splice(c,1)}function f(a){return a.replace(/(.)([A-Z])/g,function(a,b,c){return b+"-"+c}).toLowerCase()}function g(c,g,l,n,o,p){function q(a,c){if("string"==typeof a&&(a=h.querySelector(a)),!a||!m(a))return void(i&&i.error("Bad "+this.constructor.namespace+" element: "+a));this.element=a,this.options=b({},this.constructor.defaults),this.option(c);var d=++r;this.element.outlayerGUID=d,s[d]=this,this._create(),this.options.isInitLayout&&this.layout()}var r=0,s={};return q.namespace="outlayer",q.Item=p,q.defaults={containerStyle:{position:"relative"},isInitLayout:!0,isOriginLeft:!0,isOriginTop:!0,isResizeBound:!0,isResizingContainer:!0,transitionDuration:"0.4s",hiddenStyle:{opacity:0,transform:"scale(0.001)"},visibleStyle:{opacity:1,transform:"scale(1)"}},b(q.prototype,l.prototype),q.prototype.option=function(a){b(this.options,a)},q.prototype._create=function(){this.reloadItems(),this.stamps=[],this.stamp(this.options.stamp),b(this.element.style,this.options.containerStyle),this.options.isResizeBound&&this.bindResize()},q.prototype.reloadItems=function(){this.items=this._itemize(this.element.children)},q.prototype._itemize=function(a){for(var b=this._filterFindItemElements(a),c=this.constructor.Item,d=[],e=0,f=b.length;f>e;e++){var g=b[e],h=new c(g,this);d.push(h)}return d},q.prototype._filterFindItemElements=function(a){a=d(a);for(var b=this.options.itemSelector,c=[],e=0,f=a.length;f>e;e++){var g=a[e];if(m(g))if(b){o(g,b)&&c.push(g);for(var h=g.querySelectorAll(b),i=0,j=h.length;j>i;i++)c.push(h[i])}else c.push(g)}return c},q.prototype.getItemElements=function(){for(var a=[],b=0,c=this.items.length;c>b;b++)a.push(this.items[b].element);return a},q.prototype.layout=function(){this._resetLayout(),this._manageStamps();var a=void 0!==this.options.isLayoutInstant?this.options.isLayoutInstant:!this._isLayoutInited;this.layoutItems(this.items,a),this._isLayoutInited=!0},q.prototype._init=q.prototype.layout,q.prototype._resetLayout=function(){this.getSize()},q.prototype.getSize=function(){this.size=n(this.element)},q.prototype._getMeasurement=function(a,b){var c,d=this.options[a];d?("string"==typeof d?c=this.element.querySelector(d):m(d)&&(c=d),this[a]=c?n(c)[b]:d):this[a]=0},q.prototype.layoutItems=function(a,b){a=this._getItemsForLayout(a),this._layoutItems(a,b),this._postLayout()},q.prototype._getItemsForLayout=function(a){for(var b=[],c=0,d=a.length;d>c;c++){var e=a[c];e.isIgnored||b.push(e)}return b},q.prototype._layoutItems=function(a,b){function c(){d.emitEvent("layoutComplete",[d,a])}var d=this;if(!a||!a.length)return void c();this._itemsOn(a,"layout",c);for(var e=[],f=0,g=a.length;g>f;f++){var h=a[f],i=this._getItemLayoutPosition(h);i.item=h,i.isInstant=b||h.isLayoutInstant,e.push(i)}this._processLayoutQueue(e)},q.prototype._getItemLayoutPosition=function(){return{x:0,y:0}},q.prototype._processLayoutQueue=function(a){for(var b=0,c=a.length;c>b;b++){var d=a[b];this._positionItem(d.item,d.x,d.y,d.isInstant)}},q.prototype._positionItem=function(a,b,c,d){d?a.goTo(b,c):a.moveTo(b,c)},q.prototype._postLayout=function(){this.resizeContainer()},q.prototype.resizeContainer=function(){if(this.options.isResizingContainer){var a=this._getContainerSize();a&&(this._setContainerMeasure(a.width,!0),this._setContainerMeasure(a.height,!1))}},q.prototype._getContainerSize=k,q.prototype._setContainerMeasure=function(a,b){if(void 0!==a){var c=this.size;c.isBorderBox&&(a+=b?c.paddingLeft+c.paddingRight+c.borderLeftWidth+c.borderRightWidth:c.paddingBottom+c.paddingTop+c.borderTopWidth+c.borderBottomWidth),a=Math.max(a,0),this.element.style[b?"width":"height"]=a+"px"}},q.prototype._itemsOn=function(a,b,c){function d(){return e++,e===f&&c.call(g),!0}for(var e=0,f=a.length,g=this,h=0,i=a.length;i>h;h++){var j=a[h];j.on(b,d)}},q.prototype.ignore=function(a){var b=this.getItem(a);b&&(b.isIgnored=!0)},q.prototype.unignore=function(a){var b=this.getItem(a);b&&delete b.isIgnored},q.prototype.stamp=function(a){if(a=this._find(a)){this.stamps=this.stamps.concat(a);for(var b=0,c=a.length;c>b;b++){var d=a[b];this.ignore(d)}}},q.prototype.unstamp=function(a){if(a=this._find(a))for(var b=0,c=a.length;c>b;b++){var d=a[b];e(d,this.stamps),this.unignore(d)}},q.prototype._find=function(a){return a?("string"==typeof a&&(a=this.element.querySelectorAll(a)),a=d(a)):void 0},q.prototype._manageStamps=function(){if(this.stamps&&this.stamps.length){this._getBoundingRect();for(var a=0,b=this.stamps.length;b>a;a++){var c=this.stamps[a];this._manageStamp(c)}}},q.prototype._getBoundingRect=function(){var a=this.element.getBoundingClientRect(),b=this.size;this._boundingRect={left:a.left+b.paddingLeft+b.borderLeftWidth,top:a.top+b.paddingTop+b.borderTopWidth,right:a.right-(b.paddingRight+b.borderRightWidth),bottom:a.bottom-(b.paddingBottom+b.borderBottomWidth)}},q.prototype._manageStamp=k,q.prototype._getElementOffset=function(a){var b=a.getBoundingClientRect(),c=this._boundingRect,d=n(a),e={left:b.left-c.left-d.marginLeft,top:b.top-c.top-d.marginTop,right:c.right-b.right-d.marginRight,bottom:c.bottom-b.bottom-d.marginBottom};return e},q.prototype.handleEvent=function(a){var b="on"+a.type;this[b]&&this[b](a)},q.prototype.bindResize=function(){this.isResizeBound||(c.bind(a,"resize",this),this.isResizeBound=!0)},q.prototype.unbindResize=function(){this.isResizeBound&&c.unbind(a,"resize",this),this.isResizeBound=!1},q.prototype.onresize=function(){function a(){b.resize(),delete b.resizeTimeout}this.resizeTimeout&&clearTimeout(this.resizeTimeout);var b=this;this.resizeTimeout=setTimeout(a,100)},q.prototype.resize=function(){this.isResizeBound&&this.needsResizeLayout()&&this.layout()},q.prototype.needsResizeLayout=function(){var a=n(this.element),b=this.size&&a;return b&&a.innerWidth!==this.size.innerWidth},q.prototype.addItems=function(a){var b=this._itemize(a);return b.length&&(this.items=this.items.concat(b)),b},q.prototype.appended=function(a){var b=this.addItems(a);b.length&&(this.layoutItems(b,!0),this.reveal(b))},q.prototype.prepended=function(a){var b=this._itemize(a);if(b.length){var c=this.items.slice(0);this.items=b.concat(c),this._resetLayout(),this._manageStamps(),this.layoutItems(b,!0),this.reveal(b),this.layoutItems(c)}},q.prototype.reveal=function(a){var b=a&&a.length;if(b)for(var c=0;b>c;c++){var d=a[c];d.reveal()}},q.prototype.hide=function(a){var b=a&&a.length;if(b)for(var c=0;b>c;c++){var d=a[c];d.hide()}},q.prototype.getItem=function(a){for(var b=0,c=this.items.length;c>b;b++){var d=this.items[b];if(d.element===a)return d}},q.prototype.getItems=function(a){if(a&&a.length){for(var b=[],c=0,d=a.length;d>c;c++){var e=a[c],f=this.getItem(e);f&&b.push(f)}return b}},q.prototype.remove=function(a){a=d(a);var b=this.getItems(a);if(b&&b.length){this._itemsOn(b,"remove",function(){this.emitEvent("removeComplete",[this,b])});for(var c=0,f=b.length;f>c;c++){var g=b[c];g.remove(),e(g,this.items)}}},q.prototype.destroy=function(){var a=this.element.style;a.height="",a.position="",a.width="";for(var b=0,c=this.items.length;c>b;b++){var d=this.items[b];d.destroy()}this.unbindResize();var e=this.element.outlayerGUID;delete s[e],delete this.element.outlayerGUID,j&&j.removeData(this.element,this.constructor.namespace)},q.data=function(a){var b=a&&a.outlayerGUID;return b&&s[b]},q.create=function(a,c){function d(){q.apply(this,arguments)}return Object.create?d.prototype=Object.create(q.prototype):b(d.prototype,q.prototype),d.prototype.constructor=d,d.defaults=b({},q.defaults),b(d.defaults,c),d.prototype.settings={},d.namespace=a,d.data=q.data,d.Item=function(){p.apply(this,arguments)},d.Item.prototype=new p,g(function(){for(var b=f(a),c=h.querySelectorAll(".js-"+b),e="data-"+b+"-options",g=0,k=c.length;k>g;g++){var l,m=c[g],n=m.getAttribute(e);try{l=n&&JSON.parse(n)}catch(o){i&&i.error("Error parsing "+e+" on "+m.nodeName.toLowerCase()+(m.id?"#"+m.id:"")+": "+o);continue}var p=new d(m,l);j&&j.data(m,a,p)}}),j&&j.bridget&&j.bridget(a,d),d},q.Item=p,q}var h=a.document,i=a.console,j=a.jQuery,k=function(){},l=Object.prototype.toString,m="function"==typeof HTMLElement||"object"==typeof HTMLElement?function(a){return a instanceof HTMLElement}:function(a){return a&&"object"==typeof a&&1===a.nodeType&&"string"==typeof a.nodeName},n=Array.prototype.indexOf?function(a,b){return a.indexOf(b)}:function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1};"function"==typeof define&&define.amd?define("outlayer/outlayer",["eventie/eventie","doc-ready/doc-ready","eventEmitter/EventEmitter","get-size/get-size","matches-selector/matches-selector","./item"],g):"object"==typeof exports?module.exports=g(require("eventie"),require("doc-ready"),require("wolfy87-eventemitter"),require("get-size"),require("desandro-matches-selector"),require("./item")):a.Outlayer=g(a.eventie,a.docReady,a.EventEmitter,a.getSize,a.matchesSelector,a.Outlayer.Item)}(window),function(a){function b(a,b){var d=a.create("masonry");return d.prototype._resetLayout=function(){this.getSize(),this._getMeasurement("columnWidth","outerWidth"),this._getMeasurement("gutter","outerWidth"),this.measureColumns();var a=this.cols;for(this.colYs=[];a--;)this.colYs.push(0);this.maxY=0},d.prototype.measureColumns=function(){if(this.getContainerWidth(),!this.columnWidth){var a=this.items[0],c=a&&a.element;this.columnWidth=c&&b(c).outerWidth||this.containerWidth}this.columnWidth+=this.gutter,this.cols=Math.floor((this.containerWidth+this.gutter)/this.columnWidth),this.cols=Math.max(this.cols,1)},d.prototype.getContainerWidth=function(){var a=this.options.isFitWidth?this.element.parentNode:this.element,c=b(a);this.containerWidth=c&&c.innerWidth},d.prototype._getItemLayoutPosition=function(a){a.getSize();var b=a.size.outerWidth%this.columnWidth,d=b&&1>b?"round":"ceil",e=Math[d](a.size.outerWidth/this.columnWidth);e=Math.min(e,this.cols);for(var f=this._getColGroup(e),g=Math.min.apply(Math,f),h=c(f,g),i={x:this.columnWidth*h,y:g},j=g+a.size.outerHeight,k=this.cols+1-f.length,l=0;k>l;l++)this.colYs[h+l]=j;return i},d.prototype._getColGroup=function(a){if(2>a)return this.colYs;for(var b=[],c=this.cols+1-a,d=0;c>d;d++){var e=this.colYs.slice(d,d+a);b[d]=Math.max.apply(Math,e)}return b},d.prototype._manageStamp=function(a){var c=b(a),d=this._getElementOffset(a),e=this.options.isOriginLeft?d.left:d.right,f=e+c.outerWidth,g=Math.floor(e/this.columnWidth);g=Math.max(0,g);var h=Math.floor(f/this.columnWidth);h-=f%this.columnWidth?0:1,h=Math.min(this.cols-1,h);for(var i=(this.options.isOriginTop?d.top:d.bottom)+c.outerHeight,j=g;h>=j;j++)this.colYs[j]=Math.max(i,this.colYs[j])},d.prototype._getContainerSize=function(){this.maxY=Math.max.apply(Math,this.colYs);var a={height:this.maxY};return this.options.isFitWidth&&(a.width=this._getContainerFitWidth()),a},d.prototype._getContainerFitWidth=function(){for(var a=0,b=this.cols;--b&&0===this.colYs[b];)a++;return(this.cols-a)*this.columnWidth-this.gutter},d.prototype.needsResizeLayout=function(){var a=this.containerWidth;return this.getContainerWidth(),a!==this.containerWidth},d}var c=Array.prototype.indexOf?function(a,b){return a.indexOf(b)}:function(a,b){for(var c=0,d=a.length;d>c;c++){var e=a[c];if(e===b)return c}return-1};"function"==typeof define&&define.amd?define(["outlayer/outlayer","get-size/get-size"],b):"object"==typeof exports?module.exports=b(require("outlayer"),require("get-size")):a.Masonry=b(a.Outlayer,a.getSize)}(window);

$(function($){
     //Mobile nav
     $(document).on('click', '#toggle-mobile-menu, .toggle-mobile-menu', function(e){
       $('body').toggleClass('revealnav');
       return false;
     });
     
     //Return elements that have an ancestor/parent matching the supplied selector
     $.fn.hasAncestor = function(a) {
       return this.filter(function() {
         return $(this).closest(a).length > 0;
       });
     };
     
     //Side up and remove
     $.fn.slideUpAndRemove = function(speed){
       if(typeof speed == 'undefined') speed = 200;
       $(this).each(function(){
         $(this).slideUp(speed, function(){
           $(this).remove();
         });
       });
     }
     
     //Fade out image, replace src, fade back in when loaded
     $.fn.fadeToAnotherImage = function(newSrc, callback){
       var $img = $(this);
       if($img.attr('src') != newSrc) {
         $img.animate({opacity:0}, 200, function(){
           var oldHeight = $img.height();
           $img = $img.replaceImageWithOneOfNewSrc(newSrc);
           $img.css({ height: oldHeight, display: 'block' }); //Placeholder height until loaded. d:b required for occupying space in FF
           $img.imagesLoaded(function(){
             $img.css({height: '', display: ''}); //Revert to natural height
             $img.animate({opacity:1}, 200);
             if(callback) callback($img);
           });
         });
       }
       return $img;
     }
     
     $.fn.replaceImageWithOneOfNewSrc = function(newSrc) {
       //Used in a few places to avoid blank.gif breaking imagesLoaded
       var newTag = $(this).clone().wrap('<div />').parent().html();
       newTag = newTag.replace(/(src=")([^"]*)/gi, "$1" + newSrc);
       var $newTag = $(newTag);
       $(this).after($newTag).remove();
       return $newTag;
     }
     
     /// Simple function to expand/contract a div
     $(document).on('click', 'a[data-toggle-target]', function(e){
       var $target = $($(this).data('toggle-target'));
       $(this).find('.state').html( $target.is(':visible') ? '+' : '-' );
       $target.slideToggle(200);
       e.preventDefault();
     });
     
     //Already visible? Set state
     $('a[data-toggle-target]').each(function(){
       var $target = $($(this).data('toggle-target'));
       $(this).find('.state').html( $target.is(':visible') ? '-' : '+' );
     });
     
     //Redirect dropdowns
     $(document).on('change', 'select.navdrop', function(){
       window.location = $(this).val();
     });
     
     //General purpose lightbox
     $('a[rel="fancybox"]').fancybox($.extend({}, fbOpts, { titleShow: false }));
     
     /// NAV
     //Show expander plusses
     $('.multi-level-nav ul li a').each(function(){
       var $siblingUL = $(this).siblings('ul');
       if($siblingUL.length > 0) {
         if($siblingUL.hasClass('listed')) {
           $(this).addClass('listing-title');
         } else {
           $(this).append('<span class="exp">+</span>');
         }
       }
     });
     
     //Handle expanding nav
     var navAnimSpeed = 200;
     $(document).on('click', '.multi-level-nav a:has(.exp)', function(){
       //Set some useful vars
       var $tierEl = $(this).closest('[class^="tier-"]');
       var $tierCont = $tierEl.parent();
       var targetTierNum = parseInt($tierEl.attr('class').split('-')[1]) + 1;
       var targetTierClass = 'tier-' + targetTierNum;
       var $targetTierEl = $tierCont.children('.' + targetTierClass);
       
       ///Remove nav for all tiers higher than this one
       $tierCont.children().each(function(){
         if(parseInt($(this).attr('class').split('-')[1]) >= targetTierNum) {
           $(this).slideUpAndRemove(navAnimSpeed);
         }
       });
       
       //Are we expanding or collapsing
       if($(this).hasClass('expanded')) {
         //Collapsing. Reset state
         $(this).removeClass('expanded').find('.exp').html('+');
       } else {
         ///Show nav
         //Reset other nav items at this level
         $tierEl.find('a.expanded').removeClass('expanded').find('.exp').html('+');
         //If next tier div doesn't exist, make it
         if($targetTierEl.length == 0) {
           $targetTierEl = $('<div />').addClass(targetTierClass).appendTo($tierCont).hide();
         }
         $targetTierEl.empty().stop().append($(this).siblings('ul').clone()).slideDown(navAnimSpeed, function(){
           $(this).css('height', ''); //Clear height
         });
         //Mark as expanded
         $(this).addClass('expanded').find('.exp').html('-');
         
         //Scroll down if on a tiny screen
         if($tierCont.width() <= 768) {
           $('html:not(:animated),body:not(:animated)').animate({ scrollTop: $tierCont.offset().top }, 500 );
         }
       }
       
       return false;
     });
     
     $('.product-block .image-cont img[data-original]').lazyload({
       threshold : 500, //How far below the browser to load images
       skip_invisible: false, //Required for Webkit - images without size reporting 0x0, incorrectly telling jQuery :visible they're hidden
       load: function(){
         $(this).addClass('loaded');
         $(this).closest('.image-cont').addClass('img-loaded');
         //if(typeof saveCollectionPageData != 'undefined') saveCollectionPageData();
       }
      });
     
     
     
     //Generic fader
     $('.fade-load').each(function(){
       var $this = $(this);
       $(this).imagesLoaded(function(){
         $this.addClass('loaded');
       });
     });
     
     //For all image fades
     var imageFadeInSpeed = 500;
     //For fading in other images created by js
     function fadeInImageWhenReady($el, callback) {
       var $imgs = $el.is('img') ? $el : $el.find('img');
       $imgs.css('opacity', 0).imagesLoaded(function(){
         $imgs.animate({opacity: 1}, imageFadeInSpeed);
         if(callback) {
           callback();
         }
       });
     };
     
     //Enables any images inside a container
     function awakenImagesFromSlumber($cont) {
       $cont.find('img[data-src]').each(function(){
         $(this).replaceImageWithOneOfNewSrc($(this).data('src'));
       });
     };
     
     /// View modes for collection page
     $(document).on('click', '#view-as-tiles', function(){
       $(this).addClass('active');
       $('#view-as-stream').removeClass('active');
       var $listing = $('.collection-listing-stream').removeClass('collection-listing-stream').addClass('collection-listing');
       
       return false;
     });
     
     $(document).on('click', '#view-as-stream', function(){
       $(this).addClass('active');
       $('#view-as-tiles').removeClass('active');
       var $listing = $('.collection-listing').removeClass('collection-listing').addClass('collection-listing-stream');
       //All images enabled in this view (do before optionate, in case it switches images)
       awakenImagesFromSlumber($listing);
       //Close any open doodads & reset 'style=' styling to default
       $listing.find('.product-block').stop().each(function(){
         if($(this).hasClass('expanded')) {
           $(this).removeClass('expanded');
         }
         $(this).add($(this).find('.product-detail').stop()).removeAttr('style', '');
         $(this).find('select[name="id"]').trigger('optionate');
       });
       return false;
     });
     
     
      
      //For each product block in a listing
      $('.collection-listing .product-block, .collection-listing-stream .product-block').each(function(){
        //Add close button
        $('<a href="#" class="close-detail">X</a>').data('block', $(this)).appendTo($(this).find('.product-detail'));
      });
       
       
       /// Collection slider
       jQuery.fn.reverse = [].reverse; //Genius deserves credit: http://stackoverflow.com/questions/1394020/jquery-each-backwards
       
       $('.collection-slider').each(function(){
         var $nextPrevCont = $(this).find('.view-all');
         $(this).imagesLoaded(function(){
           $('<a class="prev" href="#">&larr;</a>').hide().prependTo($nextPrevCont).fadeIn().css('display', 'inline');
           $('<a class="next" href="#">&rarr;</a>').hide().appendTo($nextPrevCont).fadeIn().css('display', 'inline');
         });
       });
       $('.collection-slider').on('click', '.prev, .next', function(){
         //Find items visible in first row
         var showingNext = $(this).hasClass('next');
         var $items = $(this).closest('.collection-slider').find('.product-block');
         var $cont = $items.parent();
         var itemsToMove = [];
         var runningOffset = 0;
         if(showingNext) {
           //Next
           $items.each(function(index){
             if(index == 0) {
               runningOffset = $(this).offset().top;
               itemsToMove.push($(this));
             } else {
               if($(this).offset().top == runningOffset) {
                 itemsToMove.push($(this));
               } else {
                 return false; //Break loop
               }
             }
           });
         } else {
           //Previous
           var contWidth = $cont.width();
           $items.reverse().each(function(){
             runningOffset += $(this).outerWidth();
             if(runningOffset <= contWidth) {
               itemsToMove.push($(this));
             } else {
               return false; //Break loop
             }
           });
         }
         //Fade out
         $items.stop().animate({opacity: 0}, 500, function(){
           //Rearrange
           $.each(itemsToMove, function(index, item){
             if(showingNext) {
               $cont.append(item);
             } else {
               $cont.prepend(item);
             }
           });
           //Fade in
           $items.stop().animate({opacity: 1}, 500);
         });
         return false;
       });
       
       /// Show lightbox for any shrunken images inside certain areas
       var imageKeys = ['_pico.','_icon.','_thumb.','_small.','_compact.','_medium.','_large.','_grande.'];
       $('.lightboximages img').each(function(){
         if(!$(this).parent().is('a')) {
           var imgurl = $(this).attr('src');
           for(var i = 0; i < imageKeys.length; i++) {
             if(imgurl.indexOf(imageKeys[i]) > -1) {
               imgurl = imgurl.replace(imageKeys[i], '.');
               break;
             }
           }
           var $wrapa = $('<a>').attr('href', imgurl).addClass('fancyboximg');
           $(this).wrap($wrapa);
           $(this).parent().fancybox(fbOpts);
         }
       });
       
       /// Galleries (inc. product page)
       $(document).on('click select', '.gallery .thumbnails a', function(){
         var newMainImageURL = $(this).attr('href');
         var $mainImageArea = $(this).closest('.gallery').find('.main-image');
         var $mainATag = $mainImageArea.find('a');
         //If this is a change in main image...
         if($mainATag.data('href') != $(this).data('full-size-url')) {
           //Set active class
           $(this).addClass('active').siblings().removeClass('active');
           //Set main image data - so we know which one is selected
           $mainATag.data('href', $(this).data('full-size-url'));
           //Set link if on product page - for lightbox
           if($mainATag.hasClass('shows-lightbox')) {
             $mainATag.attr('href', $(this).data('full-size-url'));
           }
           $mainImageArea.find('img').fadeToAnotherImage(newMainImageURL, function($img){
             $img.closest('.inner').trigger('changedsize');
           });
         }
         return false;
       });
       
       /// Product variant selectors
       window.getVarOptToLink = function(prodId) {
         var optIdx = -1; //Invalid
         
          return optIdx;
          }
          
          $(document).on('optionate', 'select[name="id"]', function(){
            if(typeof $(this).data('optionated') == 'undefined') {
              $(this).data('optionated', true);
              var prodId = parseInt($(this).attr('id').split('-')[2]);
              for(var i=0; i<window.productJSON.length; i++) {
                var prodJSON = window.productJSON[i];
                if(prodJSON.id == prodId) {
                  new Shopify.OptionSelectors($(this).attr('id'), { product: prodJSON, onVariantSelected: window.selectCallback });
                  //Select first product in stock
                  for(var j=0; j < prodJSON.variants.length; j++) {
                    var variant = prodJSON.variants[j];
                    if(variant.available) {
                      for(var k=0; k<variant.options.length; k++) {
                        $('#product-select-'+prodJSON.id+'-option-'+k).val(variant.options[k]).trigger('change');
                      }
                      break;
                    }
                  }
                  
                   break;
                   }
                  }
                }
              });
              
              //Default stream view - process dropdowns right away
              $('.collection-listing-stream select[name="id"]').trigger('optionate');
              
              
               
               /// Product page
               //Dropdowns
               $('#main-product-detail select[name="id"]').trigger('optionate');
                $('#main-product-detail').on('click', '.gallery .main-image a', function(){
                  //Create list of imgs to box, so prev/next works
                  var $thumbs = $(this).closest('.gallery').find('.thumbnails');
                  if($thumbs.length > 0) {
                    //Create dupes, rejig, launch matching link
                    var $boxObjs = $thumbs.clone();
                    $('body > .t-lightbox-thumbs').remove(); //Tidy
                    $boxObjs.addClass('t-lightbox-thumbs').hide().appendTo('body').find('a').each(function(){
                      $(this).attr('href', $(this).attr('data-full-size-url'));
                    }).attr('rel', 'gallery').fancybox($.extend({}, fbOpts, { cyclic: true })).filter('[href="' + $(this).attr('href') + '"]').trigger('click');
                  } else {
                    //Create dupe of self and launch - thumbs may be hidden
                    $(this).clone().fancybox($.extend({}, fbOpts, { cyclic: true })).trigger('click');
                  }
                  return false;
                });
                
                
                /// AJAX add to cart
                /*var cartPopupTemplate = [
                  '<div id="cart-summary-overlay" class="cf">',
                  '<div class="item">',
                  '<div>'+"Just added:"+'</div>',
                  '<div class="cols">',
                  '<div class="img"><img src="[[image_url]]" /></div>',
                  '<div class="info">',
                  '<div>[[title]]</div>',
                  '<div>[[price]]</div>',
                  '</div>',
                  '<div class="detail">',
                  '<div>'+"Qty"+' [[quantity]]</div>',
                  '<div>'+"Total"+' [[line_price]]</div>',
                  '</div>',
                  '</div>',
                  '</div>',
                  '<div class="cart">',
                  '<div>',
                  "Subtotal"+' <span>[[subtotal]]</span>',
                  '</div>',
                  '<div class="cart-text">'+""+'&nbsp;</div>',
                  '<div>',
                  '<a id="shop-more" class="button arrow-button" href="#">'+"Keep Shopping"+'</a>',
                  '<a class="button" href="/cart">'+"My Cart"+'</a>',
                  '</div>',
                  '</div>',
                  '</div>'
                ].join('');*/
                 var shopifyAjaxAddURL = '/cart/add.js';
                 var shopifyAjaxCartURL = '/cart.js';
                 var shopifyAjaxStorePageURL = '/search';
                 
                 $(document).on('submit', 'form[action="/cart/add"]:not(.noAJAX)', function(e) {
                   var $form = $(this);
                   //Disable add button
                   $form.find('input[type="submit"]').attr('disabled', 'disabled').each(function(){
                     $(this).data('previous-value', $(this).val());
                   }).val('Adding...');
                   
                   //Hide any existing notifications
                   //$('#cart-summary-overlay #shop-more').triggerHandler('click');
                   
                   //Add to cart
                   $.post(shopifyAjaxAddURL, $form.serialize(), function(itemData) {
                     //Enable add button
                     $form.find('input[type="submit"]').removeAttr('disabled').each(function(){
                       $btn = $(this);
                       //Set to 'DONE', alter button style, wait a few secs, revert to normal
                       $btn.val("Added!").addClass('inverted');
                       window.setTimeout(function(){
                         $btn.removeClass('inverted').val($btn.data('previous-value'));
                       }, 3000);
                     });
                     
                     //Get our data
                     var addedDataJSON = $.parseJSON(itemData);
                     
                     //Get current cart state
                     /*$.get(shopifyAjaxCartURL, function(cartData){
                       var cartDataJSON = $.parseJSON(cartData);
                       var addedQty = parseInt($form.find('input[name="quantity"]').val());
                       
                       //Now we have all the data, build the shade
                       var cartShadeHTML = cartPopupTemplate;
                       cartShadeHTML = cartShadeHTML.replace('[[title]]', addedDataJSON.title);
                       cartShadeHTML = cartShadeHTML.replace('[[quantity]]', addedQty);
                       cartShadeHTML = cartShadeHTML.replace('[[image_url]]', addedDataJSON.image);
                       cartShadeHTML = cartShadeHTML.replace('[[price]]', Shopify.formatMoney(addedDataJSON.price));
                       cartShadeHTML = cartShadeHTML.replace('[[line_price]]', Shopify.formatMoney(addedDataJSON.price * addedQty));
                       cartShadeHTML = cartShadeHTML.replace('[[subtotal]]', Shopify.formatMoney(cartDataJSON.total_price));
                       
                       var $cartShade = $(cartShadeHTML);
                       $cartShade.find('#shop-more').bind('click', function(){
                         $cartShade.animate({top: - $cartShade.outerHeight()}, 500, function(){ $(this).remove(); });
                         return false;
                       });
                       $cartShade.prependTo('body').css('top', - $cartShade.outerHeight()).animate({top: 0}, 500);
                       
                       
                       Update currency of amount
                       Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
                       
                       }, 'html');*/
                        
                        //Update header summary
                        $.get(shopifyAjaxStorePageURL, function(data){
                          //Desktop cart
                          var cartSummarySelector = '#pageheader .cart-summary .cart-count';
                          var $newCartObj = $('<div>' + data + '</div>').find(cartSummarySelector);
                          var $currCart = $(cartSummarySelector);
                          $currCart.html($newCartObj.html());
                          //Mobile cart
                          cartSummarySelector = '#mobile-nav .cartlink';
                          $newCartObj = $('<div>' + data + '</div>').find(cartSummarySelector);
                          $currCart = $(cartSummarySelector);
                          $currCart.html($newCartObj.html());
                          
                          //Update currency of amount
                          Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
                           //performAfterCurrencyChange();
                          
                          //Show cart detail for 5 seconds
                          $('#mobile-nav .cartlink').addClass('reveal');
                           setTimeout(function(){ $('#mobile-nav .cartlink').removeClass('reveal') }, 7000);
                        });
                       }, 'text').error(function(data) {
                         //Enable add button
                         $form.find('input[type="submit"]').removeAttr('disabled').each(function(){
                           $(this).val($(this).data('previous-value'));
                         });
                         
                         //Not added, show message
                         if(typeof(data) != 'undefined' && typeof(data.status) != 'undefined') {
                           var jsonRes = $.parseJSON(data.responseText);
                           window.showQuickPopup(jsonRes.description, $form.find('input[type="submit"]:first'));
                         } else {
                           //Some unknown error? Disable ajax and add the old-fashioned way.
                           $form.addClass('noAJAX');
                           $form.submit();
                         }
                       });
                       return false;
                     });
                     /*$(window).scroll(function(){
                       //Hide notifications on scroll
                       $('#cart-summary-overlay #shop-more').triggerHandler('click');
                     });*/
                     
                     
                     //Show a quick generic text popup above an element
                     window.showQuickPopup = function(message, $origin){
                       var $popup = $('<div>').addClass('simple-popup');
                       var offs = $origin.offset();
                       $popup.html(message).css({ 'left':offs.left, 'top':offs.top }).hide();
                       $('body').append($popup);
                       $popup.css('margin-top', - $popup.outerHeight() - 10);
                       $popup.fadeIn(200).delay(3500).fadeOut(400, function(){
                         $(this).remove();
                       });
                     };
                      
                      //Start any slideshows on the page
                      $('.flexslider').each(function(){
                        $(this).flexslider({
                          animation: 'slide',
                          slideshow: $(this).hasClass('auto-play'),
                          prevText: '&lsaquo;',
                          nextText: '&rsaquo;',
                          useCSS: !$(this).hasClass('no-css-swipe'),
                          touch: $(this).find('img').length > 1,
                          directionNav: $(this).find('img').length > 1 && !$(this).hasClass('hide-direction-nav'),
                          controlNav: $(this).hasClass('show-control-nav'),
                          smoothHeight: false,
                          slideshowSpeed: 7000 // Milliseconds to wait between slides
                        });
                        //Limit height to the shortest image
                        if($(this).hasClass('size-to-shortest') && $(this).find('.slides img').length > 1) {
                          var $imgs = $(this).find('.slides li:not(.clone) img');
                          var $flex = $(this);
                          var $shortest = false;
                          var shortestH = 0;
                          $(window).on('resize checkshortestslide', function(){
                            if($shortest === false) {
                              $shortest = $imgs.first();
                              shortestH = $shortest.height();
                              $imgs.slice(1).each(function(){
                                if($(this).height() < shortestH) {
                                  $shortest = $(this);
                                  shortestH = $shortest.height();
                                }
                              });
                            } else {
                              shortestH = $shortest.height();
                            }

                            $flex.find('.slides li img').not($shortest).css({
                              height: shortestH, width: 'auto'
                            });
                          });
                          
                          $imgs.imagesLoaded(function(){
                            $(window).trigger('checkshortestslide');
                            //No height yet? Keep checking...
                            if(shortestH == 0) {
                              var slideCheckIntervalID = setInterval(function(){
                                $(window).trigger('checkshortestslide');
                                if(shortestH != 0) {
                                  clearInterval(slideCheckIntervalID);
                                }
                              }, 250);
                            }
                          });
                        }
                      });
                      
                      //Quantity inputs - select when focus
                      $(document).on('focusin click', 'input.select-on-focus', function(){
                        $(this).select();
                      }).on('mouseup', 'input.select-on-focus', function(e){
                        e.preventDefault(); //Prevent mouseup killing select()
                      });
                      
                      //Using JS in our forms?
                      $('body').addClass('jsforms');
                      /*$('#template').on('focusout keyup paste', 'input, textarea', function(){
                        $('label[for="' + $(this).attr('id') + '"]').toggle($(this).val().length == 0);
                      }).on('click', 'label', function(e){
                        $('[id="' + $(this).attr('for') + '"]').focus();
                      });*/
                      
                      //Shopify forms don't all have correct label attributes
                      $('#template label').each(function(){
                        var $sibinputs = $(this).siblings('input:not([type="submit"]), textarea');
                        if($sibinputs.length == 1 && $sibinputs.attr('id').length > 0) {
                          $(this).attr('for', $sibinputs.attr('id'));
                        }
                      });
                      
                      $(window).load(function(){
                        //Show/hide labels
                        //$('#template input').trigger('keyup');
                      });
                      
                      /// Main search input
                      $('#pageheader .search-box input[type="text"]').bind('focusin focusout', function(e){
                        $(this).closest('.search-box').toggleClass('focus', e.type == 'focusin');
                      });
                      
                      /// Live search
                      var preLoadLoadGif = $('<img src="//cdn.shopify.com/s/files/1/0750/2167/t/6/assets/ajax-load.gif?v=62939699503414190391424128463" />');
                      var searchTimeoutThrottle = 500;
                      var searchTimeoutID = -1;
                      var currReqObj = null;
                      var $resultsBox = $('<div class="results-box" />').appendTo('.search-box:not(.no-live-search)');
                      $('.search-box:not(.no-live-search) input[type="text"]').bind('keyup change', function(){
                        //Only search if search string longer than 2, and it has changed
                        if($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) {
                          //Reset previous value
                          $(this).data('oldval', $(this).val());
                          
                          // Kill outstanding ajax request
                          if(currReqObj != null) currReqObj.abort();
                          
                          // Kill previous search
                          clearTimeout(searchTimeoutID);
                          
                          var $form = $(this).closest('form');
                          
                          //Search term
                          var term = 'title:*' + $form.find('input[name="q"]').val() + '*';
                          
                          //URL for full search page
                          var linkURL = $form.attr('action') + '?type=product&q=' + term;
                          
                          //Show loading
                          $resultsBox.html('<div class="load"></div>');
                          
                          // Do next search (in X milliseconds)
                          searchTimeoutID = setTimeout(function(){
                            //Ajax hit on search page
                            currReqObj = $.ajax({
                              url: $form.attr('action'),
                              data: {
                                type: 'product',
                                view: 'json',
                                q: term,
                              },
                              dataType: "json",
                              success: function(data){
                                currReqObj = null;
                                if(data.results_total == 0) {
                                  //No results
                                  $resultsBox.html('<div class="note">'+ "No results found" +'</div>');
                                } else {
                                  //Numerous results
                                  $resultsBox.empty();
                                  $.each(data.results, function(index, item){
                                    var $row = $('<a></a>').attr('href', item.url);
                                    $row.append('<div class="img"><img src="' + item.thumb + '" /></div>');
                                    $row.append(item.title);
                                    $resultsBox.append($row);
                                  });
                                  $resultsBox.append('<a href="' + linkURL + '" class="note">See all results (' + data.results_total + ')</a>');
                                }
                              }
                            });
                          }, searchTimeoutThrottle);
                        } else if ($(this).val().length <= 2) {
                          //Deleted text? Clear results
                          $resultsBox.empty();
                        }
                          }).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function(){
                        //Focus, show results
                        $resultsBox.fadeIn(200);
                      }).bind('click', function(e){
                        //Click, prevent body from receiving click event
                        e.stopPropagation();
                      });
            $('body').bind('click', function(){
                        //Click anywhere on page, hide results
                        $resultsBox.fadeOut(200);
                      });
            
            //Search box should mimic live search string: products only, partial match
            $('.search-form, #search-form').on('submit', function(e){
              e.preventDefault();
              var term = '*' + $(this).find('input[name="q"]').val() + '*';
              var linkURL = $(this).attr('action') + '?type=product&q=' + term;
              window.location = linkURL;
            });
                      
                      /// Collection page
                      //If a tag is active in a group, other tags within that group must be links to that tag only, within that group.
                      $('.multi-tag-row .tags').each(function(){
                        var $active = $(this).find('li.active');
                        $(this).find('li:not(.active) a').each(function(){
                          var href = $(this).attr('href');
                          $active.each(function(){
                            var tag = $(this).data('tag');
                            href = href.replace('+'+tag, '').replace(tag+'+', '');
                          });
                          $(this).attr('href', href);
                        });
                      });
                      
                      
                      //Revealing social icons - re-init Facebook
                      $(document).on('click', '.page-header .social-area a.tags:not(.facebook-initd)', function(){
                        if(FB) FB.XFBML.parse();
                        $(this).addClass('facebook-initd');
                      });
                       
                       
                       //Text that scales down - scale it up/down based on column width
                       function resizeScalingTextFromColumn() {
                         $('.scaled-text').each(function(){
                           var $base = $(this).closest('.scaled-text-base');
                           var scale = $base.width() / 1200;
                                                $(this).css('font-size', (scale * 100) + '%');
                       });
                       }
                       resizeScalingTextFromColumn();
                       $(window).on('debouncedresize', resizeScalingTextFromColumn);
                       
                       //Showing dropdown signup
                       $('#pageheader .util-area .signup-reveal').bind('click', function(){
                         $(this).parent().toggleClass('show-drop');
                         return false;
                       });
                       
                       //Dropdown nav(s)
                       //$(document).on('click', '.nav-row ul li:has(.dropdown) > a, #mobile-nav .cartandlinks .signup > a', function(e){
                       $(document).on('click', '#mobile-nav .cartandlinks .signup > a', function(e){
                         e.preventDefault();
                         $(this).parent().toggleClass('expanded');
                       });
                       $(document).on('mouseenter', '.nav-row ul li > .dropdown .links a', function(){
                         var $areas = $(this).closest('.dropdown').children('.side-content').children();
                         $areas.hide();
                         $areas.filter($(this).data('matching-aside')).first().show();
                       });
                       
                       //Signup
                       $('#mobile-nav .cartandlinks .signup').on('click', function(e){
                         e.preventDefault();
                         typeof reel_open != 'undefined' && reel_open();
                         $(reelbackdrop).css('height', $(document).height()); // Update height
                       });
                       /*var signupTOID = -1;
                       $('#mobile-nav .cartandlinks .signup').on('mouseenter', function(){
                         clearTimeout(signupTOID);
                         $(this).stop(true,true).addClass('expanded');
                         return false; // Stop prop
                       });
                       $('#mobile-nav .cartandlinks .signup').on('mouseover', function(){
                         clearTimeout(signupTOID);
                         return false; // Just need to stop prop
                       });
                       $('body').on('mouseover', function(){
                         clearTimeout(signupTOID);
                         signupTOID = setTimeout(function(){
                           $('#mobile-nav .cartandlinks .signup').removeClass('expanded');
                         }, 500);
                       });*/
                       //Scroll to top button & fixed header
                       $('body').append('<a href="#" id="scrolltotop">Scroll to top</a>');
                       $(window).on('scroll load', function(){
                         var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                         $('body').toggleClass('show-scrolltop', scrollTop > 500);
                       });
                       $('#scrolltotop, .scrolltotop').click(function(){
                         $('html:not(:animated),body:not(:animated)').animate({ scrollTop: 0}, 500 );
                         return false;
                       });
                       $(window).on('resize load', function(){
                         //Fix whole header on mobiles
                         var $pageheader = $('#pageheader, #mobile-nav').addClass('permitfixed').filter('#pageheader');
                         var h = $pageheader.outerHeight();
                         if($pageheader.css('position') == 'fixed') {
                           $('#wrapall').css('padding-top', h);
                         } else {
                           $('#wrapall').css('padding-top', '');
                         }
                       });
                       
                       //Accordions
                       $(document).on('click', '.accordion-item > a', function(e){
                         e.preventDefault();
                         if($(this).parent().hasClass('active')) {
                           //Just collapse
                           $(this).siblings('div').slideUp();
                           $(this).parent().removeClass('active');
                         } else {
                           //Hide others
                           var $toReveal = $(this).siblings('div');                           
                           var $divsCollapsing = $('.accordion-item.active').removeClass('active').children('div').slideUp(200);
                           setTimeout(function(){
                             //Scroll to expanding item - if mobile
                             if($(window).width() < 768) {
                               $('html:not(:animated),body:not(:animated)').animate({ scrollTop: $toReveal.parent().offset().top - $('#pageheader').height() }, 500 );
                             }
                             //Reveal content
                             $toReveal.slideDown(200);
                             $toReveal.parent().addClass('active');
                           }, $divsCollapsing.length > 0 ? 201 : 0);
                         }
                       });
                       
                       $('#notify-me-plz').on('click', function(){
                         $('#BIS_trigger').click();
                         return false;
                       });
            
          //Main nav images load on hover
            $('.nav-row .tier-1 > ul').on('mouseover', 'li.has-dropdown', function(){
              awakenImagesFromSlumber($(this));
            });
            
            //Parent-filling images
            $('img.fill-parent').willFillParent({ closest: '.img-fill-cont', windowEvent: 'debouncedresize' });
            
          });//End of main document-ready
                      
                      
                       
                       // Custome JS Code
                       
                       // Super Scrappy notification of sold out items app fix.
                       function notifyUser(){
                         if($('#BIS_trigger').length > 0){
                           $('#BIS_trigger').fadeIn();
                         }
                       }
                        jQuery(document).ready(function($){
                          setTimeout(function(){
                            notifyUser();
                          }, 2000);
                          setTimeout(function(){
                            notifyUser();
                          }, 3000);
                          setTimeout(function(){
                            notifyUser();
                          }, 4000);
                        });
                        
                        
                        $(window).bind('scroll', function() {
                          if( $(window).width() > 1027){
                            if ($(window).scrollTop() > 180) {
                              $('#content').css('margin-top', '46px');
                              $('#main-nav').addClass('fixed');
                            }
                            else {
                              $('#main-nav').removeClass('fixed');
                              $('#content').css('margin-top', '0');
                            }
                          }
                        });
                        
                        /*$(document).ready(function(){
                          $('form input, form textarea').focus(function(){
                            if($(this).prev().is('label') && $(this).closest('form').attr('id') !== 'cartform'){
                              $(this).prev().hide();
                            }
                          });
                        });*/
                       
/// Custom share buttons
{
  $(function(){
    $('.social, .share-counter').on('click', 'a', function(e){
      var urlToShare = window.location.toString();
      var textToShare = $('meta[property="og:title"]').attr('content');
      if($(this).closest('.share-counter').length) {
        urlToShare = $(this).closest('.share-counter').data('url');
        textToShare = $(this).closest('.share-counter').data('title');
      }
      if($(this).hasClass('twitter-btn')) {
        e.preventDefault();
        var url = 'http://twitter.com/share?url=' + encodeURIComponent(urlToShare) + 
            '&text=' + encodeURIComponent(textToShare) + '&related=';
        var width  = 575,
            height = 450,
            left   = ($(window).width()  - width)  / 2,
            top    = ($(window).height() - height) / 2,
            opts   = 'status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0' +
            ',width='  + width  +
            ',height=' + height +
            ',top='    + top    +
            ',left='   + left;
        window.open(url, 'Twitter', opts);
        
      } else if($(this).hasClass('facebook-btn')) {
        e.preventDefault();
        var url = 'http://www.facebook.com/sharer.php?u=' + encodeURIComponent(urlToShare) + 
            '&t=' + encodeURIComponent(textToShare);
        var width  = 626,
            height = 256,
            left   = ($(window).width()  - width)  / 2,
            top    = ($(window).height() - height) / 2,
            opts   = 'status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0' +
            ',width='  + width  +
            ',height=' + height +
            ',top='    + top    +
            ',left='   + left;
        window.open(url, 'Facebook', opts);
        
      } else if($(this).hasClass('pinterest-btn')) {
        e.preventDefault();
        $(this).siblings().find('a').click(); //Doesn't work
        
      } else if($(this).hasClass('googleplus-btn')) {
        e.preventDefault();
        var url = 'https://plus.google.com/share?url=' + encodeURIComponent(urlToShare);
        var width  = 550,
            height = 450,
            left   = ($(window).width()  - width)  / 2,
            top    = ($(window).height() - height) / 2,
            opts   = 'status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0' +
            ',width='  + width  +
            ',height=' + height +
            ',top='    + top    +
            ',left='   + left;
        window.open(url, 'Google+', opts);
        
      }
    });
  });
}
         
$(function(){
  /* Share counter */
  function formatCount(c) {
    if(c >= 1000) {
      return Math.floor(c/1000).toFixed(0) + 'k';
    }
    return c;
  }
  $('.share-counter').each(function(){
    var totalCount = 0;
    var $area = $(this).find('.count-area');
    var url = $(this).data('url');
    //Get FB
    if(true) {
      //graph - more accurate
      $.getJSON('https://graph.facebook.com/?ids=' + url + '&callback=?', function(data){
        try{
          var count = data[url].shares;
          if(typeof data[url].shares == 'number') {
            totalCount += count;
            $area.addClass('show').find('.count').html(formatCount(totalCount));
          }
        }catch(e){
          console.log('Error fetching FB count');
        }
      });
    } else {
      //api - reports less than the graph for some reason
      $.ajax({
        dataType: 'jsonp',
        url: 'https://api.facebook.com/method/fql.query?callback=callback',
        data: {
          query: 'SELECT like_count FROM link_stat WHERE url="' + $(this).data('url') + '"',
          format: 'JSON'
        }
      }).success(function(res){
        try{
          var count = res[0].like_count;
          if(typeof res[0].like_count == 'number') {
            totalCount += count;
            $area.addClass('show').find('.count').html(formatCount(totalCount));
          }
        }catch(e){
          console.log('Error fetching FB count:1');
        }
      }).error(function(){
        console.log('Error fetching FB count:2');
      });
    }

    //Get Tweets
    $.getJSON('http://urls.api.twitter.com/1/urls/count.json?url=' + url + '&callback=?', function(data){
      try{
        var count = data.count;
        totalCount += count;
        $area.addClass('show').find('.count').html(formatCount(totalCount));
      }catch(e){
        console.log('Error fetching Tweet count');
      }
    });
    //Get Pins
    if($('.template-product').length) {
      $.getJSON('http://api.pinterest.com/v1/urls/count.json?url=' + url + '&callback=?', function(data){
        try{
          var count = data.count;
          totalCount += count;
          $area.addClass('show').find('.count').html(formatCount(totalCount));
        }catch(e){
          console.log('Error fetching Pin count');
        }
      });
    }
  });
});

//Wishlist -> your wrist
$(function($){
  if($('.wishlist-area').length) {
    window.shiftKeypresses = 0;
    $(document).on('keyup', function(e){
      if(e.keyCode == 16) window.shiftKeypresses++;
      //After 5 presses of shift...
      if(window.shiftKeypresses == 5) {
        ///   Set up wrist prototype   ///
        
        //Draggable JS
        $.fn.drags = function(opt) {

          opt = $.extend({handle:"",cursor:"move"}, opt);

          if(opt.handle === "") {
            var $el = this;
          } else {
            var $el = this.find(opt.handle);
          }

          return $el.css('cursor', opt.cursor).on("mousedown", function(e) {
            if(opt.handle === "") {
              var $drag = $(this).addClass('draggable');
            } else {
              var $drag = $(this).addClass('active-handle').parent().addClass('draggable');
            }
            var z_idx = $drag.css('z-index'),
                drg_h = $drag.outerHeight(),
                drg_w = $drag.outerWidth(),
                pos_y = $drag.offset().top + drg_h - e.pageY,
                pos_x = $drag.offset().left + drg_w - e.pageX;
            $drag.css('z-index', 1000).parents().on("mousemove", function(e) {
              $('.draggable').offset({
                top:e.pageY + pos_y - drg_h,
                left:e.pageX + pos_x - drg_w
              }).on("mouseup", function() {
                $(this).removeClass('draggable').css('z-index', z_idx);
              });
            });
            e.preventDefault(); // disable selection
          }).on("mouseup", function() {
            if(opt.handle === "") {
              $(this).removeClass('draggable');
            } else {
              $(this).removeClass('active-handle').parent().removeClass('draggable');
            }
          });

        };
        
        //Set up html
        $('.product-list').css({ width: '52%', float: 'left' })
        .find('.product-block').css({ width: '40%', height: 'auto' })
        .find('.block-inner').css('height', 'auto').find('.image-cont').css({ padding: 0, height: 'auto' });
        var $wrist = $('<div id="wrist-container"/>').css({
          float: 'right',
          position: 'relative',
          width: '45%'
        }).append($('<img/>').css('width', '100%').attr('src', "\/\/cdn.shopify.com\/s\/files\/1\/0750\/2167\/t\/6\/assets\/wristlist-arm.jpg?v=90754984304054618801424128480")).insertAfter('.product-list');
        
        //Fetch then add each image
        $('.product-list .product-block').each(function(index){
          $.get($(this).find('a:first').attr('href') + '?view=wristlist-image', function(data){
            //Add & set as draggable
            $(data).css({
              position: 'absolute',
              left: '28%',
              width: '50%',
              top: (50 + index * 5) + '%'
            }).appendTo($wrist).drags().hover(function(){
              $(this).css('outline', '1px solid #999');
            }, function(){
              $(this).css('outline', '');
            });
          });
        });
      }
    });
  }
});

$(document).ready( function () {
  function registerMC($form) {
    $('.signup-form-cont .res').remove();
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action').replace('/post?', '/post-json?').concat('&c=?'),
      data: $form.serialize(),
      cache       : false,
      dataType    : 'jsonp',
      contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success     : function(data) {
        if (data.result != "success") {
          $('.signup-form-cont').prepend('<div class="res error">' + data.msg.replace('0 - ', '') + '</div>');
        } else {
          $('.signup-form-cont').prepend('<div class="res success">' + data.msg + '</div>');
          $('.signup-form-cont .signup-form').remove();
        }
      }
    });
  }
  // I only have one form on the page but you can be more specific if need be.
  var $form = $('#mc-embedded-subscribe-form');

  if ( $form.length > 0 ) {
    $('#mc-embedded-subscribe-form input[type="submit"]').bind('click', function ( event ) {
      if ( event ) event.preventDefault();
      // validate_input() is a validation function I wrote, you'll have to substitute this with your own.
      //if ( validate_input($form) ) { registerMC($form); }
      registerMC($form);
    });
  }
});


/*!
* Clamp.js 0.5.1
*
* Copyright 2011-2013, Joseph Schmitt http://joe.sh
* Released under the WTFPL license
* http://sam.zoy.org/wtfpl/
*/
(function(){window.$clamp=function(c,d){function s(a,b){n.getComputedStyle||(n.getComputedStyle=function(a,b){this.el=a;this.getPropertyValue=function(b){var c=/(\-([a-z]){1})/g;"float"==b&&(b="styleFloat");c.test(b)&&(b=b.replace(c,function(a,b,c){return c.toUpperCase()}));return a.currentStyle&&a.currentStyle[b]?a.currentStyle[b]:null};return this});return n.getComputedStyle(a,null).getPropertyValue(b)}function t(a){a=a||c.clientHeight;var b=u(c);return Math.max(Math.floor(a/b),0)}function x(a){return u(c)*
a}function u(a){var b=s(a,"line-height");"normal"==b&&(b=1.2*parseInt(s(a,"font-size")));return parseInt(b)}function l(a){if(a.lastChild.children&&0<a.lastChild.children.length)return l(Array.prototype.slice.call(a.children).pop());if(a.lastChild&&a.lastChild.nodeValue&&""!=a.lastChild.nodeValue&&a.lastChild.nodeValue!=b.truncationChar)return a.lastChild;a.lastChild.parentNode.removeChild(a.lastChild);return l(c)}function p(a,d){if(d){var e=a.nodeValue.replace(b.truncationChar,"");f||(h=0<k.length?
k.shift():"",f=e.split(h));1<f.length?(q=f.pop(),r(a,f.join(h))):f=null;m&&(a.nodeValue=a.nodeValue.replace(b.truncationChar,""),c.innerHTML=a.nodeValue+" "+m.innerHTML+b.truncationChar);if(f){if(c.clientHeight<=d)if(0<=k.length&&""!=h)r(a,f.join(h)+h+q),f=null;else return c.innerHTML}else""==h&&(r(a,""),a=l(c),k=b.splitOnChars.slice(0),h=k[0],q=f=null);if(b.animate)setTimeout(function(){p(a,d)},!0===b.animate?10:b.animate);else return p(a,d)}}function r(a,c){a.nodeValue=c+b.truncationChar}d=d||{};
var n=window,b={clamp:d.clamp||2,useNativeClamp:"undefined"!=typeof d.useNativeClamp?d.useNativeClamp:!0,splitOnChars:d.splitOnChars||[".","-","\u2013","\u2014"," "],animate:d.animate||!1,truncationChar:d.truncationChar||"\u2026",truncationHTML:d.truncationHTML},e=c.style,y=c.innerHTML,z="undefined"!=typeof c.style.webkitLineClamp,g=b.clamp,v=g.indexOf&&(-1<g.indexOf("px")||-1<g.indexOf("em")),m;b.truncationHTML&&(m=document.createElement("span"),m.innerHTML=b.truncationHTML);var k=b.splitOnChars.slice(0),
h=k[0],f,q;"auto"==g?g=t():v&&(g=t(parseInt(g)));var w;z&&b.useNativeClamp?(e.overflow="hidden",e.textOverflow="ellipsis",e.webkitBoxOrient="vertical",e.display="-webkit-box",e.webkitLineClamp=g,v&&(e.height=b.clamp+"px")):(e=x(g),e<=c.clientHeight&&(w=p(l(c),e)));return{original:y,clamped:w}}})();
$(function(){
  $('.template-blog .article-list .article .user-content').each(function(){
    $clamp($(this)[0], {clamp: 10});
  });
});